export default "__VITE_ASSET__BTLuJqcE__$_?nuxt_component=async&nuxt_component_name=SvgoCkbChoiceLogo&nuxt_component_export=default__"